import React, { useEffect, useContext } from 'react';
import { appContext } from "../AppContext";
import {
  Mobile,
  // DefaultDevice
} from '../utils/mediaQuery'
import { Card, Select } from 'antd';

const { Option } = Select;

export default function HomePage() {

    //eslint-disable-next-line
     const [appState, AppDispatch] = useContext(appContext);

      useEffect(() => {
        AppDispatch({ type: "SETSELECTEDPAGE", payload: "Home" })
      }, // eslint-disable-next-line
      [])

      function handleChangeSelectStory(value) {

        const selectedStory = appState.stories.find(story => story.id === value)
        AppDispatch({ type: "SETSTORYID", payload: {storyId:value, storyName:selectedStory.name} })
        localStorage.setItem('LarpTOM.StoryId', value);
        localStorage.setItem('LarpTOM.StoryName', selectedStory.name);
      }
      
      const storieOptions = appState.stories.map(story => {
        if(story.name === "Zivania" && !appState.user.isAdmin) {
          return null;
        }
        return (<Option 
          value={story.id} 
          key={story.id}
        >
          {story.name}
        </Option>)
      })

    return (
      <>
        <p>Welcome to the LarpTOM app. This app is still in development and will be updated quite frequently. If there are any questions or feedback on the website let someone from the LarpTOM Team know</p>

        <Card style={{width:"300px"}} title="Join us on Discord">
          <a target='_blank' rel="noopener noreferrer" href="https://discord.gg/YrMAksM">Discord</a>
        </Card>
        <Mobile>
          <p>Please select the Series you want to see data from</p>
            <Select 
                onChange={handleChangeSelectStory}
                value={parseInt(appState.storyId)}
                >
                    {storieOptions} 
            </Select>
        </Mobile>
      </>
    )
}